import { useState, useEffect } from 'react';
import Stack from '@mui/joy/Stack';

import Button from '@mui/joy/Button';

import { FileType } from 'stores/file_store';
import useFile from 'hooks/useFile';
import useUserIdentity from 'hooks/useUserIdentity';
import { getIcon } from 'utils/misc';

function FileAudioPlayer({ association_uuid }: { association_uuid: string }) {
    const [loadingUrl, setLoadingUrl] = useState(false);
    const [haveUrl, setHaveUrl] = useState(false);
    const [url, setUrl] = useState('');
    const { getDownloadUrl } = useFile();
    const { currentIdentity } = useUserIdentity();
    const VolumeUpIcon = getIcon('VolumeUp');
    function doLoadUrl() {
        setLoadingUrl(true);
        getDownloadUrl(
            currentIdentity.uuid,
            association_uuid,
            'inline'
        ).then((url) => {
            setLoadingUrl(false);
            if(url) {
            setHaveUrl(true);
                setUrl(url);
            }
        });

    }
    //    console.log('file:', file.uuid);
    return (
        <Stack>
    { !(haveUrl) &&
        <Button
            variant="plain"
            size="sm"
            endDecorator={<VolumeUpIcon />}
            loading={loadingUrl}
            onClick={() => doLoadUrl()}>
            Show Player
        </Button>
    }
        { url &&
            <audio controls autoPlay>
                <source src={url} />
            </audio> }
    </Stack>
    );
}



export default function FileAssociation({uuid}:{uuid: string}) {
    const { fetchFile } = useFile();
    const { currentIdentity } = useUserIdentity();
    const [fetching, setFetching] = useState(false);
    const [file, setFile] = useState<FileType | null>(null);

    useEffect(() => {
        if(fetching) return;
        if(currentIdentity.uuid) {
            setFetching(true);
            fetchFile(currentIdentity.uuid, uuid)
                .then((assoc) => {
                    setFetching(false);
                    // console.log(assoc);
                    setFile(assoc);
                });
        }
    }, [currentIdentity.uuid, uuid]);

    return (
        <Stack direction="row" my={1}>
            {file?.content_type == 'audio/mpeg' &&
                <FileAudioPlayer
                    association_uuid={uuid} />
            }
        </Stack>
    );
}
